"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortLists = void 0;
/** Sorts lists by type (Favorite first) and then by lastUpdate date which can be undefined. */
const sortLists = lists => lists.sort((a, b) => {
  if (a.type === 'Favorite' && b.type !== 'Favorite') {
    return -1;
  }
  if (a.type !== 'Favorite' && b.type === 'Favorite') {
    return 1;
  }
  if (a.lastUpdate && b.lastUpdate) {
    return new Date(b.lastUpdate).getTime() - new Date(a.lastUpdate).getTime();
  }
  return 0;
});
exports.sortLists = sortLists;
//# sourceMappingURL=sortLists.js.map